import { render, staticRenderFns } from "./labelEntry.vue?vue&type=template&id=3f977e3c&"
import script from "./labelEntry.vue?vue&type=script&lang=js&"
export * from "./labelEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports